import { useState, useEffect, useRef } from "react";
import { supabase } from '../supabase/supabaseClient';
import { useParams } from 'react-router-dom';
import Mono from "../Components/Colorize/ColorizeModes/Mono";
import Duo from "../Components/Colorize/ColorizeModes/Duo";
import Trio from "../Components/Colorize/ColorizeModes/Trio";
import Modules from "../Components/Modules";
import { getContrastRatio } from "../Components/Colorize/getTextColor";
import chroma from "chroma-js";
import '../Styles/home.scss';
import '../Styles/share.scss';
import '../Styles/Colorize/squares.scss';
import Header from "../Components/ReusableComponents/Header";


function Share({ darkMode }) {
  const { '*': id } = useParams();

  const [palette, setPalette] = useState([]);
  const [paletteDuo, setPaletteDuo] = useState([]);
  const [paletteTrio, setPaletteTrio] = useState([]);
  const [color, setColor] = useState('');
  const [colorDuo, setColorDuo] = useState('');
  const [colorTrio, setColorTrio] = useState('');
  // const [colorName, setColorName] = useState('');
  // const [colorNameDuo, setColorNameDuo] = useState('');
  // const [colorNameTrio, setColorNameTrio] = useState('');
  const [showDuo, setShowDuo] = useState(false);
  const [showTrio, setShowTrio] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedIndexDuo, setSelectedIndexDuo] = useState(null);
  const [selectedIndexTrio, setSelectedIndexTrio] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editIndexDuo, setEditIndexDuo] = useState(null);
  const [editIndexTrio, setEditIndexTrio] = useState(null);
  const [paletteModifiers, setPaletteModifiers] = useState({
    scale: { hue: 0, lightnessLeft: 0, lightnessRight: 0, saturationLeft: 0, saturationRight: 0 },
    individual: {}
  });
  const [paletteModifiersDuo, setPaletteModifiersDuo] = useState({
    scale: { hue: 0, lightnessLeft: 0, lightnessRight: 0, saturationLeft: 0, saturationRight: 0 },
    individual: {}
  });
  const [paletteModifiersTrio, setPaletteModifiersTrio] = useState({
    scale: { hue: 0, lightnessLeft: 0, lightnessRight: 0, saturationLeft: 0, saturationRight: 0 },
    individual: {}
  });
  const [squareNames] = useState(["50", "100", "200", "300", "400", "500", "600", "700", "800", "900", "950"]);
  const [isLoaded, setIsLoaded] = useState(false);

  const monoRef = useRef(null);
  const duoRef = useRef(null);
  const trioRef = useRef(null);


  useEffect(() => {
    const fetchSharedPalette = async () => {
      try {
        const { data, error } = await supabase
          .from('shared_palettes')
          .select('*')
          .eq('id', id)
          .single();

        if (error || !data) {
          console.error('Error fetching shared palette:', error);
          return;
        }

        const { palettes, showDuo: sd, showTrio: st } = data.palette_data;

        setShowDuo(sd || false);
        setShowTrio(st || false);

        if (palettes.mono) {
          setColor(palettes.mono.color);
          setPaletteModifiers(palettes.mono.paletteModifiers);
        }
        if (palettes.duo) {
          setColorDuo(palettes.duo.color);
          setPaletteModifiersDuo(palettes.duo.paletteModifiers);
        }
        if (palettes.trio) {
          setColorTrio(palettes.trio.color);
          setPaletteModifiersTrio(palettes.trio.paletteModifiers);
        }

        function waitForRef(ref, callback) {
          let attempts = 0;
          function check() {
            if (ref.current?.loadSavedPalette) {
              callback();
            } else if (attempts++ < 60) {
              requestAnimationFrame(check);
            }
          }
          requestAnimationFrame(check);
        }

        if (palettes.mono) {
          waitForRef(monoRef, () => {
            monoRef.current.loadSavedPalette({
              ...palettes.mono,
              skipRegeneration: true
            });
          });
        }

        if (sd && palettes.duo) {
          waitForRef(duoRef, () => {
            duoRef.current.loadSavedPalette({
              ...palettes.duo,
              skipRegeneration: true
            });
          });
        }

        if (st && palettes.trio) {
          waitForRef(trioRef, () => {
            trioRef.current.loadSavedPalette({
              ...palettes.trio,
              skipRegeneration: true
            });
          });
        }

        setIsLoaded(true);

      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (id) fetchSharedPalette();
  }, [id]);



  return (
    <div className="share">

      {/* Hidden Mono/Duo/Trio — only used for palette generation, not rendered visibly */}
      <div style={{ display: 'none' }}>
        <Mono
          ref={monoRef}
          color={color || '#000000'}
          setColor={setColor}
          palette={palette}
          setPalette={setPalette}
          selectionMode='mono'
          selectionName='PRIMARY'
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          editIndex={editIndex}
          setEditIndex={setEditIndex}
          paletteModifiers={paletteModifiers}
          setPaletteModifiers={setPaletteModifiers}
          squareNames={squareNames}
          // setBaseColorName={setColorName}
          onSave={() => { }}
          onOpenExport={() => { }}
          onOpenExportToFigma={() => { }}
          onOpenContrastGrid={() => { }}
          onColorChange={() => { }}
          onModifiersChange={() => { }}
          onTailwindFamilyChange={() => { }}
          isUpdatingFromURL={false}
        />
        {showDuo && (
          <Duo
            ref={duoRef}
            color={colorDuo || '#000000'}
            setColor={setColorDuo}
            palette={paletteDuo}
            setPalette={setPaletteDuo}
            selectionMode='duo'
            selectionName='SECONDARY'
            selectedIndex={selectedIndexDuo}
            setSelectedIndex={setSelectedIndexDuo}
            editIndex={editIndexDuo}
            setEditIndex={setEditIndexDuo}
            paletteModifiers={paletteModifiersDuo}
            setPaletteModifiers={setPaletteModifiersDuo}
            squareNames={squareNames}
            // setBaseColorName={setColorNameDuo}
            onSave={() => { }}
            onOpenExport={() => { }}
            onOpenExportToFigma={() => { }}
            onOpenContrastGrid={() => { }}
            onColorChange={() => { }}
            onModifiersChange={() => { }}
            onTailwindFamilyChange={() => { }}
            isUpdatingFromURL={false}
          />
        )}
        {showTrio && (
          <Trio
            ref={trioRef}
            color={colorTrio || '#000000'}
            setColor={setColorTrio}
            palette={paletteTrio}
            setPalette={setPaletteTrio}
            selectionMode='trio'
            selectionName='TERTIARY'
            selectedIndex={selectedIndexTrio}
            setSelectedIndex={setSelectedIndexTrio}
            editIndex={editIndexTrio}
            setEditIndex={setEditIndexTrio}
            paletteModifiers={paletteModifiersTrio}
            setPaletteModifiers={setPaletteModifiersTrio}
            squareNames={squareNames}
            // setBaseColorName={setColorNameTrio}
            onSave={() => { }}
            onOpenExport={() => { }}
            onOpenExportToFigma={() => { }}
            onOpenContrastGrid={() => { }}
            onColorChange={() => { }}
            onModifiersChange={() => { }}
            onTailwindFamilyChange={() => { }}
            isUpdatingFromURL={false}
          />
        )}
      </div>

      <Header
        titleHighlighted={`Color ${showDuo ? 'palette' : 'scale'} `}
      >
      </Header>

      {/* Visible UI — squares and modules only */}
      {isLoaded && (
        <>
        <div className="show-squares--container">

          <div className="squares">
            <div className="squares--container">
              {palette.map((shade, idx) => (
                <div
                  key={idx}
                  className={`square-container ${selectedIndex === idx ? 'picked-color' : ''} ${editIndex === idx ? 'edit-indiv' : ''}`}
                >
                  <div
                    className="square"
                    style={{
                      backgroundColor: palette[idx],
                      color: getContrastRatio(palette[idx], '#ffffff') > 2.0
                        ? '#ffffff' : '#211f1c'
                    }}
                  >
                    {selectedIndex === idx && (
                      <svg className="flag-icon" xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 17 17" fill="none">
                        <ellipse cx="5.66667" cy="15.2292" rx="5.66667" ry="1.77083" fill="currentColor" />
                        <path d="M16.2923 1.41667H6.37565V0H4.95898V14.1667H6.37565V8.5H16.2923L14.8757 4.95833L16.2923 1.41667ZM12.0423 4.95833C12.0423 5.7375 11.4048 6.375 10.6257 6.375C9.84648 6.375 9.20898 5.7375 9.20898 4.95833C9.20898 4.17917 9.84648 3.54167 10.6257 3.54167C11.4048 3.54167 12.0423 4.17917 12.0423 4.95833Z" fill="currentColor" />
                      </svg>
                    )}
                    <p className="variable">{squareNames[idx]}</p>
                    <p className="color-code">
                      {(shade.startsWith('hsl') ? chroma(shade).hex() : shade).replace('#', '')}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {showDuo && (
            <div className="squares">
              <div className="squares--container">
                {paletteDuo.map((shade, idx) => (
                  <div
                    key={idx}
                    className={`square-container ${selectedIndexDuo === idx ? 'picked-color' : ''} ${editIndexDuo === idx ? 'edit-indiv' : ''}`}
                  >
                    <div
                      className="square"
                      style={{
                        backgroundColor: paletteDuo[idx],
                        color: getContrastRatio(paletteDuo[idx], '#ffffff') > 2.0
                          ? '#ffffff' : '#211f1c'
                      }}
                    >
                      {selectedIndexDuo === idx && (
                        <svg className="flag-icon" xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 17 17" fill="none">
                          <ellipse cx="5.66667" cy="15.2292" rx="5.66667" ry="1.77083" fill="currentColor" />
                          <path d="M16.2923 1.41667H6.37565V0H4.95898V14.1667H6.37565V8.5H16.2923L14.8757 4.95833L16.2923 1.41667ZM12.0423 4.95833C12.0423 5.7375 11.4048 6.375 10.6257 6.375C9.84648 6.375 9.20898 5.7375 9.20898 4.95833C9.20898 4.17917 9.84648 3.54167 10.6257 3.54167C11.4048 3.54167 12.0423 4.17917 12.0423 4.95833Z" fill="currentColor" />
                        </svg>
                      )}
                      <p className="variable">{squareNames[idx]}</p>
                      <p className="color-code">
                        {(shade.startsWith('hsl') ? chroma(shade).hex() : shade).replace('#', '')}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {showTrio && (
            <div className="squares">
              <div className="squares--container">
                {paletteTrio.map((shade, idx) => (
                  <div
                    key={idx}
                    className={`square-container ${selectedIndexTrio === idx ? 'picked-color' : ''} ${editIndexTrio === idx ? 'edit-indiv' : ''}`}
                  >
                    <div
                      className="square"
                      style={{
                        backgroundColor: paletteTrio[idx],
                        color: getContrastRatio(paletteTrio[idx], '#ffffff') > 2.0
                          ? '#ffffff' : '#211f1c'
                      }}
                    >
                      {selectedIndexTrio === idx && (
                        <svg className="flag-icon" xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 17 17" fill="none">
                          <ellipse cx="5.66667" cy="15.2292" rx="5.66667" ry="1.77083" fill="currentColor" />
                          <path d="M16.2923 1.41667H6.37565V0H4.95898V14.1667H6.37565V8.5H16.2923L14.8757 4.95833L16.2923 1.41667ZM12.0423 4.95833C12.0423 5.7375 11.4048 6.375 10.6257 6.375C9.84648 6.375 9.20898 5.7375 9.20898 4.95833C9.20898 4.17917 9.84648 3.54167 10.6257 3.54167C11.4048 3.54167 12.0423 4.17917 12.0423 4.95833Z" fill="currentColor" />
                        </svg>
                      )}
                      <p className="variable">{squareNames[idx]}</p>
                      <p className="color-code">
                        {(shade.startsWith('hsl') ? chroma(shade).hex() : shade).replace('#', '')}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          </div>

          <Modules
            colors={palette}
            colorsDuo={paletteDuo}
            colorsTrio={paletteTrio}
            selectedOption={showTrio ? 'trio' : showDuo ? 'duo' : 'mono'}
            showDuo={showDuo}
            showTrio={showTrio}
            darkMode={darkMode}
          />
        </>
      )}
    </div>
  );
}

export default Share;